import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=95f51294&scoped=true&"
import script from "./TransactionItem.vue?vue&type=script&lang=js&"
export * from "./TransactionItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionItem.vue?vue&type=style&index=0&id=95f51294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f51294",
  null
  
)

export default component.exports